import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-home-projects",
  templateUrl: "./home-projects.component.html",
  styleUrls: ["./home-projects.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule, MatTooltipModule],
})
export class HomeProjectsComponent implements OnInit {
  public categories: string[] = [];
  public projects: any[] = [
    {
      title: "GB_Registration_Project1_Title",
      img: "/assets/images/projects/sm/p1.webp",
      category: "",
      tags: "",
      url: "key-facts-of-the-cartels",
    },
    {
      title: "GB_Registration_Project3_Title",
      img: "/assets/images/projects/sm/p3.webp",
      category: "",
      tags: "",
      url: "affected-markets",
    },
    {
      title: "GB_Registration_Project4_Title",
      img: "/assets/images/projects/sm/p4.webp",
      category: "",
      tags: "",
      url: "cartel-members",
    },
    {
      title: "GB_Registration_Project2_Title",
      img: "/assets/images/projects/sm/p2.webp",
      category: "",
      tags: "",
      url: "appels-procedures",
    },

    {
      title: "GB_Registration_Project5_Title",
      img: "/assets/images/projects/sm/p5.webp",
      category: "",
      tags: "",
      url: "limitation-periods",
    },
    {
      title: "GB_Registration_Project6_Title",
      img: "/assets/images/projects/sm/p6.webp",
      category: "",
      tags: "",
      url: "how-to-prepare-your-information",
    },
  ];

  constructor() {}

  ngOnInit(): void {
    this.getCategories();
  }

  getCategories(): void {
    if (this.projects?.length < 1) {
      return;
    }

    this.categories = this.projects
      .map((project: any) => project.tags)
      .filter((category) => category);
  }
}
